export default "__VITE_ASSET__D6ahQKM5__"